module.exports = __webpack_public_path__ + "static/media/Regional_Beneficiary.bf0c10a6.svg";